import { Spinner } from "../Spinner";

function LogoCircle() {
  return (
    <svg viewBox="353.498 12.9807 135 135" className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient
          gradientTransform="matrix(87.3438 0 0 87.3438 370.998 67.9338)"
          gradientUnits="userSpaceOnUse"
          id="pgLinearGradient1"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
        >
          <stop offset="0" stopColor="#f6cbcb" />
          <stop offset="1" stopColor="#9ecad6" />
        </linearGradient>
        <linearGradient
          gradientTransform="matrix(87.2813 2.08916e-16 3.89316e-14 87.2812 383.716 93.0276)"
          gradientUnits="userSpaceOnUse"
          id="pgLinearGradient2"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
        >
          <stop offset="0" stopColor="#f6cbcb" />
          <stop offset="1" stopColor="#9ecad6" />
        </linearGradient>
      </defs>
      <path
        d="M353.498 80.4807C353.498 43.2015 383.718 12.9807 420.998 12.9807C458.277 12.9807 488.498 43.2015 488.498 80.4807C488.498 117.76 458.277 147.981 420.998 147.981C383.718 147.981 353.498 117.76 353.498 80.4807Z"
        fill="#000000"
      />
      <path
        d="M420.998 30.4807C393.383 30.4807 370.997 52.8665 370.998 80.4807C370.998 89.6004 373.639 98.0258 377.904 105.387L412.56 85.3869L406.31 74.5744L384.248 87.2932C383.812 85.0799 383.497 82.8269 383.498 80.4807C383.498 59.77 400.287 42.9807 420.998 42.9807C431.321 42.9807 440.685 47.1373 447.466 53.8869L458.341 47.4807C449.18 37.1201 435.915 30.4806 420.998 30.4807Z"
        fill="url(#pgLinearGradient1)"
      />
      <path
        d="M464.123 55.5744L429.498 75.5744L435.748 86.3869L457.779 73.6682C458.21 75.8755 458.497 78.1413 458.498 80.4807C458.498 101.191 441.708 117.981 420.998 117.981C410.683 117.981 401.371 113.783 394.591 107.043L383.716 113.449C392.877 123.801 406.087 130.481 420.998 130.481C448.612 130.481 470.998 108.095 470.998 80.4807C470.998 71.3673 468.382 62.9322 464.123 55.5744Z"
        fill="url(#pgLinearGradient2)"
      />
    </svg>
  );
}

export function PageLoading() {
  return (
    <div className="min-h-screen bg-background-primary flex items-center justify-center">
      <div className="relative flex items-center justify-center">
        <Spinner className="h-[100px] w-[100px]" strokeWidth={5} />
        <div className="absolute w-20 h-20">
          <LogoCircle />
        </div>
      </div>
    </div>
  );
}
